import { ChakraSimpleGrid as SimpleGrid } from "@airhelp/react-ui-components";
import useDeviceSize from "hooks/useDeviceSize";
import { TeamCard } from "./TeamCard/TeamCard";
import type { TeamCardsProps } from "./TeamCards.d";
import { TeamCardsMobile } from "./TeamCardsMobile";

export const TeamCards = ({ cards }: TeamCardsProps) => {
  const { isMobile } = useDeviceSize();

  return isMobile ? (
    <TeamCardsMobile cards={cards} />
  ) : (
    <SimpleGrid columns={cards.length % 2 ? { base: 1, lg: 3 } : { base: 2, lg: 3 }} spacing={8} alignContent="center">
      {cards.map(({ imageSrc, name, position, description }) => (
        <TeamCard key={name} imageSrc={imageSrc} name={name} position={position} description={description} />
      ))}
    </SimpleGrid>
  );
};
